import {
  groupByDesign,
  useProject,
} from '@customink/project-service-react-components';

export const useProjectItemsByDesign = (designCid: string) => {
  const { data: project } = useProject();

  if (!project || !project.items) {
    return { items: [], isMultiStyle: false };
  }

  const itemsByDesign = groupByDesign(project.items);
  const items = itemsByDesign[designCid] || [];
  const isMultiStyle = items.length > 1;

  return { items, isMultiStyle };
};
